var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition-group',{staticClass:"movie-list",attrs:{"tag":"div","name":"flip-list"}},_vm._l((_vm.movies),function(movie,i){return _c('movie',{key:("movie-" + (movie.id)),attrs:{"movie":movie,"tabindex":i}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }